import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyledNavLink } from 'modules/styled/web';
import { getRoutes } from '../utils';
import { useRequireRole, MemberRole } from 'modules/community';
import { Row, Header } from 'modules/styled';

const DiscoverTabs = ({ view, community }) => {
  const isOwner = useRequireRole(MemberRole.OWNER);
  return (
    <Row>
      {getRoutes(isOwner).map((linkData, i) => (
        <DiscoverTab
          key={i}
          tag={view?.discover?.tag}
          community={community}
          linkData={linkData}
        />
      ))}
    </Row>
  );
};

DiscoverTabs.propTypes = {
  view: PropTypes.object,
  community: PropTypes.string,
};

const DiscoverTab = (props) => {
  const { linkData, community, tag } = props;
  let url = community ? `/${community}/${linkData.key}` : '/communities';
  if (tag) url += `/${tag}`;

  return (
    <StyledNavLink to={encodeURI(url)}>
      <Header sx={{ color: 'grey', fontSize: [18, 3], mr: [8.001, 10.001] }}>
        {linkData.title}
      </Header>
    </StyledNavLink>
  );
};

DiscoverTab.propTypes = {
  linkData: PropTypes.object,
  community: PropTypes.string,
  tag: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    view: state.navigation,
    community: state.auth.community,
  };
}

export default connect(mapStateToProps)(DiscoverTabs);
